<template>
    <sections>
        <section-jumbo
            padding="pt-32 pb-24 sm:pt-40 sm:pb-32 lg:pt-44 lg:pb-36 xl:pt-64 xl:pb-56"
            color="bg-zinc-800"
            :video="$config.public.videos + 'lauren-jones-jumbo-jaden.mp4'"
            videoOpacity="opacity-40"
            heading="Online Course"
            headingColor="text-white"
            content="<p>Watch the first two lessons for free!</p>"
            contentColor="text-zinc-100"
            buttonText="Free Preview"
            :buttonUrl="$config.public.courseUrl"
            :textCentered="false"
        ></section-jumbo>
        <section-cookies></section-cookies>
        <section-hero
            heading="All-Star West Coast Swing Dancer"
            headingComponent="h2"
            content="<article-home />"
            :image="hero.image"
            :imageSet="hero.imageSet"
            :imageSizes="hero.imageSizes"
        ></section-hero>
        <section-image
            color="bg-zinc-50"
            :image="course.image"
            :imageSet="course.imageSet"
            :imageSizes="course.imageSizes"
            heading="Online Course!"
            headingComponent="h2"
            content="<article-home-course />"
            buttonText="Free Preview"
            :buttonUrl="$config.public.courseUrl"
        ></section-image>
        <section-image
            color="bg-white"
            :image="privates.image"
            :imageSet="privates.imageSet"
            :imageSizes="privates.imageSizes"
            heading="Private Lessons"
            headingComponent="h2"
            content="<article-home-privates />"
            buttonText="Book Privates"
            buttonRoute="/privates"
            :flip="true"
        ></section-image>
        <section-image
            color="bg-zinc-50"
            :image="shoes.image"
            :imageSet="shoes.imageSet"
            :imageSizes="shoes.imageSizes"
            heading="Dance Shoes"
            headingComponent="h2"
            content="<article-home-shoes />"
            buttonText="The Shoes"
            buttonRoute="/shoes"
        ></section-image>
        <section-image
            color="bg-white"
            :image="$config.public.images + 'events-calendar.jpg'"
            heading="Events"
            headingComponent="h2"
            content="<p>Lauren's upcoming West Coast Swing events.</p>"
            buttonText="Events Calendar"
            buttonRoute="/events"
            :flip="true"
        ></section-image>
        <section-text
            color="bg-zinc-50"
            heading="What is West Coast Swing?"
            headingComponent="h2"
            content="<article-home-what />"
        ></section-text>
        <section-text heading="Why Do I Love It?" headingComponent="h2" content="<article-home-why />"></section-text>
        <section-text
            color="bg-zinc-50"
            heading="Learn West Coast Swing!"
            headingComponent="h2"
            content="<p>Want to dance like Lauren? Affinity Swing maintains an awesome map of global classes. Find a West Coast Swing class near you.</p>"
            buttonText="Find a Class"
            buttonUrl="https://www.affinityswing.com/classes"
        ></section-text>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();

// https://www.responsivebreakpoints.com/
// https://cloudinary.com/tools/jpg-to-webp
const hero = {
    imageSizes: '(max-width: 1200px) 100vw, 1200px',
    imageSet: `
        ${$config.public.images}home-hero-512.webp 512w,
        ${$config.public.images}home-hero-874.webp 874w,
        ${$config.public.images}home-hero-1200.webp 1200w
    `,
    image: `${$config.public.images}home-hero.jpg`,
};

const course = {
    imageSizes: '(max-width: 1024px) 100vw, 1024px',
    imageSet: `
        ${$config.public.images}online-course-512.webp 512w,
        ${$config.public.images}online-course-906.webp 906w,
        ${$config.public.images}online-course-1024.webp 1024w
    `,
    image: `${$config.public.images}online-course.jpg`,
};

const privates = {
    imageSizes: '(max-width: 1024px) 100vw, 1024px',
    imageSet: `
        ${$config.public.images}private-lessons-512.webp 512w,
        ${$config.public.images}private-lessons-870.webp 870w,
        ${$config.public.images}private-lessons-1024.webp 1024w
    `,
    image: `${$config.public.images}private-lessons.jpg`,
};

const shoes = {
    imageSizes: '(max-width: 1200px) 100vw, 1200px',
    imageSet: `
        ${$config.public.images}dance-shoes-512.webp 512w,
        ${$config.public.images}dance-shoes-1200.webp 1200w
    `,
    image: `${$config.public.images}dance-shoes.jpg`,
};

useSeo().buildHead({
    title: $config.public.siteName + ' | West Coast Swing Dancer',
    description: $config.public.siteStrapline,
    index: true,
});
</script>
